import Section from '@shared/components/Section';
import { SectionProps } from '@shared/types/section';
import classNames from 'classnames';
import { FC } from 'react';

const NoPageImageSection: FC<SectionProps> = ({ className, ...props }) => (
  <Section {...props} className={classNames(className, 'no-page-image')} />
);

export default NoPageImageSection;
